var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "invoiceDetail"
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("开具发票方式")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("开具发票方式")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.data.typeName)))])])]), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("发票信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("抬头类型")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.data.taxpayerTypeName) || "-"))])]), _vm.data.taxpayerType === "C" ? [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("发票抬头")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.invoiceHead || "-"))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("纳税人识别号")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.taxpayerNo || "-"))])])] : [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("开票姓名")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.invoiceHead || "-"))])])], _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("发票内容")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t("保险费")))])]), _c("div", {
    staticClass: "moneyBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("序号")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v("1")])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("金额")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.price || "-"))])])]), _vm.data.taxpayerType === "C" ? [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("开户行名称")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.companyBank || "-"))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("开户行账号")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.companyAccount || "-"))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("公司联系电话")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.companyTel || "-"))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("公司地址")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.companyAddress || "-"))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("备注信息")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.remark || "-"))])])] : _vm._e()], 2), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))])]), _c("div", {
    staticClass: "receiveType"
  }, [_vm.data.mobile ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t("手机号")))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("手机号")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.mobile))])])]) : _vm._e(), _vm.data.email ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t("电子邮箱")))])]), _c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("电子邮箱")))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.data.email))])])]) : _vm._e()]), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("关联保单")))])]), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.tablePageChange
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.data.status === "SUCCESS" ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("其他信息")))])]) : _vm._e(), _vm.data.status === "SUCCESS" ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("发票附件")))]), _vm.data.localUrl != "" ? _c("div", {
    staticClass: "right"
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.checkInvoice
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查看发票")) + " ")])], 1) : _vm._e()]), _c("div", [_c("div", {
    staticClass: "right"
  }, [_vm.data.isInvoiceOffset === 1 && _vm.data.status === "SUCCESS" ? _c("a-button", {
    attrs: {
      type: "danger",
      size: "small"
    },
    on: {
      click: function ($event) {
        _vm.showModal = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("作废")) + " ")]) : _vm._e()], 1)])]) : _vm._e(), _c("a-modal", {
    attrs: {
      title: _vm.$t("警告提示"),
      closable: false,
      centered: true,
      confirmLoading: _vm.confirmLoading,
      width: "390px"
    },
    on: {
      ok: _vm.invoiceOffsetConfirm
    },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c("h3", [_c("a-icon", {
    staticStyle: {
      color: "#faad14",
      "margin-right": "5px",
      "font-size": "20px"
    },
    attrs: {
      type: "exclamation-circle"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("作废发票")) + " ")], 1), _c("div", {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t("点击确认后该发票所包含的保单将被释放，释放保单后原发票将被作废 请谨慎操作！")))])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };